import { getISBN } from "../viewer/selectors";
import {
  INIT_SERVICE_PREFIX,
  LOAD_ENRICHMENT_STATUS_PREFIX,
  LOAD_MANIFEST_PREFIX,
  LoadEnrichmentResponse,
  LoadEnrichmentStatusParams,
} from "./types";
import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";
import {
  getEnrichmentStatusLoadStatus,
  getManifestLoadStatus,
  getServicesLoadStatus,
} from "./selectors";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  serviceGetAssessmentStatus,
  serviceInitEnrichmentsService,
  serviceInitTightrope,
  serviceLoadManifest,
} from "../../../../../../services/enrichments";

export const loadManifestIfNeeded = () => (dispatch, getState) => {
  const state = getState();
  if (getManifestLoadStatus(state) === DetailedLoadStatus.WAITING) {
    return dispatch(loadManifest());
  }
};

export const loadManifest = createAsyncThunk(
  LOAD_MANIFEST_PREFIX,
  async (arg: void, { getState, rejectWithValue }): Promise<any> => {
    const isbn = getISBN(getState());
    return serviceInitEnrichmentsService()
      .then(() => {
        return serviceLoadManifest(isbn).then((manifest) => {
          if (manifest.data) {
            return manifest.data;
          } else {
            // Empty response. Shouldn't happen, but just in case.
            return rejectWithValue({ errorCode: 404 });
          }
        });
      })
      .catch((error) => {
        return rejectWithValue({ errorCode: error.status || 500 });
      });
  },
  {
    condition: (arg: void, { getState }) => {
      if (getManifestLoadStatus(getState()) === DetailedLoadStatus.FETCHING) {
        return false;
      }
    },
  }
);

export const initTightrope = createAsyncThunk(
  INIT_SERVICE_PREFIX,
  async (args: any, { getState }): Promise<void> => {
    const isbn = getISBN(getState());
    return serviceInitTightrope(args.sessionId, isbn);
  },
  {
    condition: (arg: void, { getState }) => {
      if (getServicesLoadStatus(getState()) !== DetailedLoadStatus.WAITING) {
        return false;
      }
    },
  }
);

export const loadEnrichmentStatus = createAsyncThunk<
  Promise<LoadEnrichmentResponse>,
  LoadEnrichmentStatusParams
>(
  LOAD_ENRICHMENT_STATUS_PREFIX,
  async (args: LoadEnrichmentStatusParams, { getState }): Promise<any> => {
    return serviceGetAssessmentStatus(args.enrichmentIds);
  },
  {
    condition: (arg: any, { getState }) => {
      if (
        getEnrichmentStatusLoadStatus(getState()) ===
        DetailedLoadStatus.FETCHING
      ) {
        return false;
      }
    },
  }
);
